if (!customElements.get("video-products-group")) {
    customElements.define("video-products-group", class VideoProductsGroup extends HTMLElement {
        constructor() {
            super();
            // 缓存常用 DOM 元素
            this.groupSwiperEl = this.querySelector(".video-products-group-swiper");
            this.tabs = this.querySelectorAll('.video-products-group-tab-item');

            this.mainSwiper = null;
            this.itemSwipers = [];
        }

        connectedCallback() {
            if (this.initialized) return;

            this.initGroupSwiper();
            this.initGroupItemSwiper();
            this.initGroupTab();
            this.fixRate();

            this.initialized = true;
        }

        disconnectedCallback() {
            if (this.mainSwiper) this.mainSwiper.destroy();
            this.itemSwipers.forEach(swiper => swiper.destroy());
        }

        initGroupSwiper() {
            if (!this.groupSwiperEl) return;

            this.mainSwiper = new Swiper(this.groupSwiperEl, {
                slidesPerView: 1,
                spaceBetween: 12,
                effect: "fade",
                fadeEffect: { crossFade: true },
                allowTouchMove: false,
            });
        }

        initGroupTab() {
            this.tabs.forEach((tab, index) => {
                tab.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!this.mainSwiper) return;

                    if (!tab.classList.contains('active')) {
                        this.updateActiveTab(tab);
                        this.mainSwiper.slideTo(index);
                    }
                });
            });
        }

        updateActiveTab(targetTab) {
            this.tabs.forEach((t) => t.classList.remove('active'));
            targetTab.classList.add('active');
        }

        initGroupItemSwiper() {
            const swiperEls = this.querySelectorAll('.video-products-group-item-swiper');

            swiperEls.forEach((el) => {
                const parent = el.parentElement;
                const prev = parent?.querySelector(".swiper-button-prev");
                const next = parent?.querySelector(".swiper-button-next");
                const scrollbar = el.querySelector(".swiper-scrollbar");

                const swiper = new Swiper(el, {
                    slidesPerView: 4,
                    spaceBetween: 12,
                    scrollbar: { el: scrollbar },
                    navigation: { nextEl: next, prevEl: prev },
                    breakpoints: {
                        320: {
                            slidesPerView: 2,
                            spaceBetween: 6,
                            grid: { fill: 'row', rows: 2 },
                        },
                        768: { slidesPerView: 3, spaceBetween: 12 },
                        1400: { slidesPerView: 4, spaceBetween: 12 }
                    }
                });

                this.itemSwipers.push(swiper);
            });
        }

        fixRate() {
            if (typeof Shopify === 'undefined' || !Shopify.currency) return;

            const rate = parseFloat(Shopify.currency.rate);
            // 如果汇率是 1 或者无效，直接返回
            if (isNaN(rate) || rate === 1) return;

            const formatMoney = themeVendor?.themeCurrency?.formatMoney;
            if (!formatMoney) return;

            const items = this.querySelectorAll('.video-products-group-item');

            const updatePriceEl = (container, selector) => {
                const el = container.querySelector(selector);
                const basePrice = el?.dataset?.calcPrice;

                if (el && basePrice) {
                    el.innerText = formatMoney(basePrice * rate, theme.moneyFormat);
                }
            };

            items.forEach((item) => {
                updatePriceEl(item, '.current-price');
                updatePriceEl(item, 'del');
                updatePriceEl(item, '.video-products-group-product-item-sale-tag-text strong');
            });
        }
    });
}